'use client';

import { Suspense } from 'react';
import AnnualReturn from '../components/AnnualReturn';
import AnnualReturnSkeleton from '../components/AnnualReturnSkeleton';
import type { AnnualReturnData } from '@/types/annual-return';

interface AnnualReturnClientProps {
  locale: string;
  data: AnnualReturnData | null;
}

export default function AnnualReturnClient({ locale, data }: AnnualReturnClientProps) {
  return (
    <Suspense fallback={<AnnualReturnSkeleton />}>
      <AnnualReturn locale={locale} data={data} />
    </Suspense>
  );
}
